@if (isVisible()) {
<div [id]="navLink.id" class="udex-mb-32 udex-lg-mb-0 product-details-section">
  <div class="udex-grid udex-mx-auto">
    <h2 class="heading__regular--l text-center udex-mb-32">
      {{ navLink.headline | cxTranslate }}
    </h2>

    <div class="row mb-sm-6">
      <div class="col-12 d-flex justify-content-start justify-content-sm-center resource-link-wrapper">
        <div class="d-flex flex-wrap flex-sm-row">
          @if (support()?.knowledgebase) {
          <div class="resource-link">
            <a [href]="support()!.knowledgebase"
              class="btn btn-link udex-p-0 udex-m-0 d-flex flex-nowrap align-items-center"
              data-cy="resource-support-page" target="_blank">
              <img alt="open book image" class="me-3" src="/images/education_blue.svg" />
              {{ 'productDetails.supportPage' | cxTranslate }}
            </a>
          </div>
          }
          @if (support()?.email) {
          <div class="resource-link">
            <a [href]="'mailto:' + support()!.email"
              class="btn btn-link udex-p-0 udex-m-0 d-flex flex-nowrap align-items-center"
              data-cy="resource-contact-support" target="_blank">
              <img alt="headset image" class="me-3" src="/images/headset_blue.svg" />
              {{ 'productDetails.contactSupport' | cxTranslate }}
            </a>
          </div>
          }
          @if (privacy()) {
          <div class="resource-link">
            <a [href]="privacy()" class="btn btn-link udex-p-0 udex-m-0 d-flex flex-nowrap align-items-center"
              data-cy="resource-privacy-statement" target="_blank">
              <img alt="security shield" class="me-3" src="/images/badge_blue.svg" />
              {{ 'productDetails.privacyStatement' | cxTranslate }}
            </a>
          </div>
          }
          <div class="resource-link">
            @if (terms()) {
            <a [href]="terms()" (click)="onTermsClick($event)"
              class="btn btn-link udex-p-0 udex-m-0 d-flex flex-nowrap align-items-center"
              data-cy="resource-terms-and-conditions" target="_blank">
              <img alt="legal paper" class="me-3" src="/images/newspaper_blue.svg" />
              {{ 'productDetails.termsAndConditions' | cxTranslate }}
            </a>
            }
            @if (!terms() && !hideTermsAndConditionsSection()) {
            <dcp-terms-conditions [entry]="termsConditionsProductEntries()[0]"
              [entries]="termsConditionsProductEntries()" [isStoreHeaderShown]="true"
              [pdpTerms]="{isPdpTerms: true, showIconLink: true}" [resourceSection]="true"
              (entriesEmpty)="onEntriesEmpty($event)">
            </dcp-terms-conditions>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="w-100 separator d-none d-sm-block"></div>
  </div>

  @if (resources().length > 1) {
  <div class="udex-grid udex-mx-auto d-none d-lg-block">
    <div [class.justify-content-center]="resources().length < entryLimit" class="row desktop-row">
      @for (resource of limitedResources(); track $index) {
      <div class="col-3 flex-column desktop-tile">
        <dcp-product-resource-tile [resource]="resource"></dcp-product-resource-tile>
      </div>
      }
    </div>
    @if (resources().length > entryLimit) {
    <div class="col d-flex justify-content-center">
      <udex-button [design]="resourcesExtended() ? 'Secondary' : 'Primary'" (click)="toggleResources()">
        {{ (resourcesExtended() ? 'productDetails.lessResources' : 'productDetails.moreResources') | cxTranslate }}
      </udex-button>
    </div>
    }
  </div>
  }
  @if (resources().length === 1) {
  <div class="d-none d-lg-block">
    <dcp-product-single-resource-tile [resource]="resources()[0]"></dcp-product-single-resource-tile>
  </div>
  }

  <div class="d-lg-none horizontal-scrolling">
    <div class="horizontal-scrolling__row">
      @for (resource of resources(); track $index) {
      @if (resource.value) {
      <div class="horizontal-scrolling__tile">
        <dcp-product-resource-tile [resource]="resource"></dcp-product-resource-tile>
      </div>
      }
      }
    </div>
  </div>
</div>

<div class="udex-legacy-shadow d-none d-lg-block udex-my-32"></div>
}
